import React, { Suspense, useCallback } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { log } from 'log';

import { parseHTMLAttributes } from '@interlayer/js/app/utils/common.util';

import { componentService } from 'js/services/component.service';

export const useParseHub2Components = () => {
    const components = componentService.getWebContentComponents();

    return useCallback((content = '') => {
        try {
            const options = {
                replace: (node) => {
                    const { attribs = {}, name, children, prev, next } = node;
                    if (/^hub2-/.test(name)) {
                        // name of the tag does stats with "hub2-"
                        const componentName = name?.replace(/^hub2-|-/g, '');

                        if (components[componentName]) {
                            const Component = components[componentName];

                            return (
                                <>
                                    {prev?.type === 'text' && prev.data?.endsWith(' ') && <>&nbsp;</>}

                                    <Suspense fallback="">
                                        <Component {...parseHTMLAttributes(attribs)}>{domToReact(children, options)}</Component>
                                    </Suspense>

                                    {next?.type === 'text' && next.data?.startsWith(' ') && <>&nbsp;</>}
                                </>
                            );
                        }
                    }
                }
            };
            const parsed = parse(content.toString(), options);

            return Array.isArray(parsed)
                ? parsed.map((item, index) => {
                    const next = parsed[index + 1];
                    const prev = parsed[index - 1];

                    if (next && typeof next !== 'string' && item?.endsWith(' ')) {
                        return item.substring(0, item.length - 1);
                    }

                    if (prev && typeof prev !== 'string' && item?.startsWith(' ')) {
                        return item.substring(1, item.length);
                    }

                    return item;
                })
                : parsed;
        } catch (error) {
            log('error', `Wrong syntax \n ${content.toString()}`);

            return '';
        }
    }, [components]);
};
